document.addEventListener("DOMContentLoaded", function () {
  const locomotiveScroll = new LocomotiveScroll();
});
// colr generator
document.addEventListener("DOMContentLoaded", function () {
  let lastHue = null;

  function getRandomLightColor() {
    let hue;
    if (lastHue === null) {
      hue = Math.floor(Math.random() * 360);
    } else {
      // Shift by at least 60 degrees to ensure colors are visibly different
      const shift = Math.floor(Math.random() * 240) + 60;
      hue = (lastHue + shift) % 360;
    }
    lastHue = hue;
    return `hsl(${hue}, 40%, 94%)`; // ultra-light pastel shade
  }

  document.querySelectorAll(".br-collectCard__imgBg").forEach((el) => {
    el.style.setProperty("--random-color", getRandomLightColor());
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // active class on wishlist
  document.querySelectorAll(".wishlist").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.classList.toggle("active");
    });
  });

  document.querySelectorAll(".br-wishlist").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      this.classList.toggle("active");
    });
  });
});
// active class on wishlist ends

// add to cart
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".add-to-cart").forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault(); // stop anchor navigation
      e.stopPropagation(); // stop parent click
    });
  });
});

// // product zoom code starts
// // Desktop only matching
// document.addEventListener("DOMContentLoaded", function () {
//   if (window.matchMedia("(min-width: 992px)").matches) {
//     const tiles = document.querySelectorAll(".product-img--main");

//     tiles.forEach((tile) => {
//       // create image container
//       const imgDiv = document.createElement("div");
//       imgDiv.className = "product-img--main__image";
//       imgDiv.style.backgroundImage = `url(${tile.dataset.image})`;

//       tile.appendChild(imgDiv);

//       // mouse over -> zoom
//       tile.addEventListener("mouseover", () => {
//         imgDiv.style.transform = `scale(${tile.dataset.scale})`;
//       });

//       // mouse out -> reset
//       tile.addEventListener("mouseout", () => {
//         imgDiv.style.transform = "scale(1)";
//       });

//       // mouse move -> zoom focus
//       tile.addEventListener("mousemove", (e) => {
//         const rect = tile.getBoundingClientRect();

//         const x = ((e.clientX - rect.left) / rect.width) * 100;
//         const y = ((e.clientY - rect.top) / rect.height) * 100;

//         imgDiv.style.transformOrigin = `${x}% ${y}%`;
//       });
//     });
//   }
// });
// // product zoom code ends

//product slider details page
document.addEventListener("DOMContentLoaded", function () {
  const splide = new Splide(".br-productSplide", {
    perPage: 4,
    perMove: 1,
    gap: "20px",
    arrows: false, // disable default arrows
    pagination: false,
    // autoplay: true,
    // interval: 1500,
    breakpoints: {
      1024: { perPage: 3 },
      992: { perPage: 2 },
      768: { perPage: 2 },
      370: { perPage: 1 },
    },
  });

  splide.mount();

  // custom arrows control
  document
    .querySelector(".br-productSlider__arrows .lft")
    .addEventListener("click", () => splide.go("<"));

  document
    .querySelector(".br-productSlider__arrows .rgt")
    .addEventListener("click", () => splide.go(">"));
});

// hero banner home slider starts
document.addEventListener("DOMContentLoaded", function () {
  const splide = new Splide(".br-heroSplide", {
    type: "loop",
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: true,
    autoplay: true,
    interval: 5000,
    pauseOnHover: false,
    pauseOnFocus: false,
  });

  splide.mount();

  // Custom arrows for hero banner
  const leftArrow = document.querySelector(".br-herobnnr__lftarw");
  const rightArrow = document.querySelector(".br-herobnnr__rgtarw");

  if (leftArrow) {
    leftArrow.addEventListener("click", () => splide.go("<"));
  }
  if (rightArrow) {
    rightArrow.addEventListener("click", () => splide.go(">"));
  }

  // Pause autoplay when focusing on the search bar
  const searchInputs = document.querySelectorAll(".br-herobnnr__search input");
  searchInputs.forEach((input) => {
    input.addEventListener("focus", () => {
      splide.Components.Autoplay.pause();
    });
    // Resume autoplay when clicking/swiping away
    input.addEventListener("blur", () => {
      splide.Components.Autoplay.play();
    });
  });
});

// hero banner home slider ends

// protectionSlider start
window.addEventListener("load", function () {
  const splideEl = document.querySelector(".br-protectionSplide");
  if (!splideEl) return;

  const splide = new Splide(splideEl, {
    type: "loop",
    perPage: 2,
    padding: { right: "15%" },
    gap: "30px",
    focus: "left",
    arrows: false,
    pagination: true,
    speed: 800,
    easing: "ease",
    drag: true,
    autoplay: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    trimSpace: false,
    clones: 4, // Important for smooth loop

    breakpoints: {
      1199: { perPage: 2 },
      991: { perPage: 1.5 },
      767: { perPage: 1, padding: { right: "0" } },
    },
  });

  splide.mount();

  document
    .querySelector(".br-protectionSlider__arrows .lft")
    ?.addEventListener("click", () => splide.go("<"));

  document
    .querySelector(".br-protectionSlider__arrows .rgt")
    ?.addEventListener("click", () => splide.go(">"));
});
// protectionSlider end

// video slider starts
document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector(".br-videoSlider__splide");

  if (!splideEl) return;

  const splide = new Splide(splideEl, {
    type: "loop",
    perPage: 3,
    perMove: 1,
    arrows: false,
    pagination: false,
    gap: "30px",
    autoplay: true,
    interval: 4000,
    breakpoints: {
      991: {
        perPage: 2,
      },
      767: {
        perPage: 2,
         gap: "15px",
      },
    },
  });

  splide.mount();

  const leftArrow = document.querySelector(".br-videoSlider__arrows .lft");
  const rightArrow = document.querySelector(".br-videoSlider__arrows .rgt");

  if (leftArrow) {
    leftArrow.addEventListener("click", () => splide.go("<"));
  }

  if (rightArrow) {
    rightArrow.addEventListener("click", () => splide.go(">"));
  }
});
// video slider ends

document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".br-videoSlider__card");

  const isTouchDevice = window.matchMedia("(hover: none)").matches;

  cards.forEach((card) => {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".video-play-btn");

    video.pause();
    video.muted = true;

    // ---------- DESKTOP HOVER ----------
    if (!isTouchDevice) {
      card.addEventListener("mouseenter", () => {
        video.muted = false;
        const playPromise = video.play();

        // Browsers block playing unmuted video if the user hasn't interacted with the page yet.
        // If it throws an error securely fallback to playing muted visually!
        if (playPromise !== undefined) {
          playPromise.catch((error) => {
            video.muted = true;
            video.play();
          });
        }
      });

      card.addEventListener("mouseleave", () => {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
      });
    }

    // ---------- MOBILE TAP ----------
    if (isTouchDevice && playBtn) {
      playBtn.addEventListener("click", (e) => {
        e.stopPropagation();

        // pause other videos
        document
          .querySelectorAll(".br-videoSlider__card video")
          .forEach((v) => {
            if (v !== video) {
              v.pause();
              v.muted = true;
            }
          });

        video.muted = false;
        video.play();
        playBtn.style.display = "none";
      });
    }
  });
});

// review slider starts
document.addEventListener("DOMContentLoaded", function () {
  const splideEl = document.querySelector("#reviewSlider");

  if (!splideEl) return;

  const splide = new Splide(splideEl, {
    type: "loop",
    perPage: 1,
    perMove: 1,
    arrows: false,
    pagination: false,
    autoplay: true,
    interval: 2000,
    pauseOnHover: true,
  });

  splide.mount();

  const leftArrow = document.querySelector(".br-reviewSec__btn-outer .lft");
  const rightArrow = document.querySelector(".br-reviewSec__btn-outer .rgt");

  if (leftArrow) {
    leftArrow.addEventListener("click", () => splide.go("<"));
  }

  if (rightArrow) {
    rightArrow.addEventListener("click", () => splide.go(">"));
  }
});
// review slider ends

// Mobile header search toggle starts
document.addEventListener("DOMContentLoaded", function () {
  const toggle = document.getElementById("searchToggleBtn"); // desktop search toggle
  const box = document.getElementById("searchFormWrap"); // desktop search box
  
  const mobToggleBtn = document.querySelector(".br-header__search-mob .search-toggle");
  const mobSearchBox = document.querySelector(".br-header__search-mob .search-box");
  const mobSearchClose = document.querySelector(".br-header__search-mob .search-close");

  // Desktop search behavior
  if (toggle && box) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      box.classList.toggle("active");

      if (box.classList.contains("active")) {
        box.querySelector("input").focus();
      }
    });

    // document.addEventListener("click", function () {
    //   box.classList.remove("active");
    // });

    // box.addEventListener("click", function (e) {
    //   e.stopPropagation();
    // });
  }

  // Mobile search popup behavior
  if (mobToggleBtn && mobSearchBox) {
    mobToggleBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      mobSearchBox.classList.add("active");
      document.body.classList.add("search-open");
      
      setTimeout(() => {
        mobSearchBox.querySelector("input").focus();
      }, 100);
    });

    if (mobSearchClose) {
      mobSearchClose.addEventListener("click", function (e) {
        e.stopPropagation();
        mobSearchBox.classList.remove("active");
        document.body.classList.remove("search-open");
      });
    }

    document.addEventListener("click", function (e) {
      if (!mobSearchBox.contains(e.target) && !mobToggleBtn.contains(e.target)) {
        mobSearchBox.classList.remove("active");
        document.body.classList.remove("search-open");
      }
    });

    mobSearchBox.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  // cart drawer toggle starts
  const cartToggleBtn = document.getElementById("cartToggleBtn");
  const cartDrawer = document.getElementById("cartDrawer");
  const navCloseBtns = document.querySelectorAll(
    "#navClose, .tu-btn-blk[id='navClose']",
  );

  if (cartToggleBtn && cartDrawer) {
    cartToggleBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      cartDrawer.classList.toggle("active");
      document.body.classList.toggle("cart-open");
    });

    if (navCloseBtns.length > 0) {
      navCloseBtns.forEach((btn) => {
        btn.addEventListener("click", function (e) {
          e.preventDefault();
          e.stopPropagation();
          cartDrawer.classList.remove("active");
          document.body.classList.remove("cart-open");
        });
      });
    }

    document.addEventListener("click", function (e) {
      if (!cartDrawer.contains(e.target) && !cartToggleBtn.contains(e.target)) {
        cartDrawer.classList.remove("active");
        document.body.classList.remove("cart-open");
      }
    });

    cartDrawer.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }
  // cart drawer toggle ends
});
// Mobile header search toggle ends




// tab scroll button
document.addEventListener("DOMContentLoaded", function () {
  (function () {
    const tabList = document.getElementById("nav-tab");
    const arrowLeft = document.getElementById("tabArrowLeft");
    const arrowRight = document.getElementById("tabArrowRight");

    if (!tabList || !arrowLeft || !arrowRight) return;

    const SCROLL_AMOUNT = 160;

    function updateArrows() {
      const atStart = tabList.scrollLeft <= 4;
      const atEnd =
        tabList.scrollLeft + tabList.clientWidth >= tabList.scrollWidth - 4;
      arrowLeft.disabled = atStart;
      arrowRight.disabled = atEnd;
      arrowLeft.classList.toggle("br-tab-arrow--hidden", atStart);
      arrowRight.classList.toggle("br-tab-arrow--hidden", atEnd);
    }

    arrowLeft.addEventListener("click", function () {
      tabList.scrollBy({ left: -SCROLL_AMOUNT, behavior: "smooth" });
    });

    arrowRight.addEventListener("click", function () {
      tabList.scrollBy({ left: SCROLL_AMOUNT, behavior: "smooth" });
    });

    tabList.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    // Initial state
    updateArrows();
  })();
});

// product inner slider
document.addEventListener("DOMContentLoaded", function () {
  var main = new Splide("#main-slider", {
    type: "fade",
    heightRatio: 0.5,
    pagination: false,
    arrows: false,
    cover: true,
  });

  var thumbnails = new Splide("#thumbnail-slider", {
    rewind: true,
    fixedWidth: "48%",
    fixedHeight: 296,
    isNavigation: true,
    gap: 10,
    pagination: false,
    cover: true,
    arrows: false,
    dragMinThreshold: {
      mouse: 4,
      touch: 10,
    },
    breakpoints: {
      640: {
        fixedWidth: "40%",
        fixedHeight: 196,
      },
    },
  });

  main.sync(thumbnails);
  main.mount();
  thumbnails.mount();

  document.querySelectorAll(".br-productSlider__img").forEach((elem) => {
    let img = elem.querySelector("img");
    elem.addEventListener("mousemove", function (e) {
      const rect = elem.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = `${x}% ${y}%`;
    });
    elem.addEventListener("mouseleave", function () {
      img.style.transformOrigin = "center";
    });
  });
});

